import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import RelatedEventsLogsService from "../../app/data/documents/relatedEventsLogsService";
import { initialRelatedEventsLogsState } from "./relatedEventsLogsState";
import { RelatedEventsLogsFilterModel } from "../../app/data/documents/relatedEventsLogsModels";

const relatedEventsLogsService = RelatedEventsLogsService.getInstance();

export const relatedEventsLogsSlice = createSlice({
    name: "relatedEventsLogs",
    initialState: initialRelatedEventsLogsState,
    reducers: {
        requestStarted: (state, { payload }) => {
            state.requestStarted = true;
            state.requestSucceed = false;
            state.requestFailed = false;
            state.requestError = "";
            state.requestCreator = payload;
        },
        requestSucceed: (state) => {
            state.requestStarted = false;
            state.requestSucceed = true;
        },
        requestFailed: (state, { payload }) => {
            state.requestStarted = false;
            state.requestSucceed = false;
            state.requestFailed = true;
            state.requestError = payload;
        },
        resetErrors: (state) => {
            state.requestFailed = false;
            state.requestError = "";
        },
        setRecordsRequest: (state, { payload }) => {
            state.recordsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
        addItemRecords: (state, { payload }) => {
            state.recordItems = [...state.recordItems, ...payload];
        },
        setItemRecords: (state, { payload }) => {
            state.recordItems = payload;
        },
        setRelatedEventsCsvDownload: (state, { payload }) => {
            state.downloadCsv = payload;
        },
        setTableInfo: (state, { payload }) => {
          state.tableInfo = payload;
      }
    }
});

export const {
    requestStarted,
    requestSucceed,
    requestFailed,
    resetErrors,
    setItemRecords,
    addItemRecords,
    setRecordsRequest,
    setRelatedEventsCsvDownload,
    setTableInfo
} = relatedEventsLogsSlice.actions;

export const relatedEventsLogsSelector = (state: IState) => state.relatedEventsLogs;

export const getRelatedEventsLogs = (
    filter: RelatedEventsLogsFilterModel,
    page: number
): AppThunk => async (dispatch) => {
    dispatch(requestStarted(page !== 1 ? "GET_RECORDS_PORTION" : "GET_RECORDS"));
    const response = await relatedEventsLogsService.getRelatedEventsLogsRecords(filter, page);
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setRecordsRequest({
            page: response.data?.page,
            last: response.data?.totalPages
        }));
        dispatch(page !== 1 ? addItemRecords(response.data.data) : setItemRecords(response.data.data));
        dispatch(requestSucceed());
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};
export const updateRelatedEventsHistoryCsvDownload = (downloadCsv: boolean): AppThunk => (dispatch) => {
    dispatch(setRelatedEventsCsvDownload(downloadCsv));
};

export const getRelatedEventsTableInfo = (): AppThunk => async (dispatch) => {
    const response = await relatedEventsLogsService.getRelatedEventsTableInfo();
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setTableInfo(response.data));
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};

const relatedEventsLogsReducer = relatedEventsLogsSlice.reducer;
export default relatedEventsLogsReducer;
